<template>
  <div class="table-responsive">
    <table id="table_list" class="table table-striped table-bordered table-hover dataTables-example">
      <thead>
      <tr>
        <th>ID</th>
        <th>Descrição Documento</th>
        <th>Download</th>
        <th class="text-center">+</th>
      </tr>
      </thead>

      <tbody v-if="documentos.length" class="overflow-auto" style="max-height: 300px">
        <tr v-for="documento in documentos" :key="documento.id" :id="'linha_' + documento.key">
          <td class="text-right">{{ documento.id }}</td>
          <td>{{ documento.descricao }}</td>
          <td class="text-center"><a :href="documento.documento" class="btn btn-success fa fa-download" target="_blank"></a></td>
          <td class="text-center cursor-pointer"><i class="btn btn-danger btn-sm fa fa-trash"
                                     @click="deletarDocModelo(documento.key, documento.id, documento.descricao)"></i></td>
        </tr>
      </tbody>

      <tbody v-else>
        <tr>
          <td :colspan="6" class="text-center">Não existe documentos no momento</td>
        </tr>
      </tbody>
    </table>
  </div>
  <br>
  <hr>
  <div class="float-right">
    <button type="submit" class="btn btn-primary font-bold" @click="abrirModal()">Adicionar Documento</button>
  </div>
  <button class="btn btn-success font-bold" @click="$emit('fechar')">
    Fechar
  </button>
  <BaseDocCadastro
      v-if="exibirModal"
      :origemId="itemKey"
      :origemApp="'MODELOS'"
      @fecharSubModal="exibirModal = false"
      @atualizarListaDoc="atualizarDoc"
  />
</template>

<script>
import BaseDocCadastro from '@/components/base/BaseDocCadastro.vue';
import {apiRequest, alertDelete} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";

export default {
  name: 'DocumentosModelo',
  props: {
    itemKey: String,
  },
  components: {
    BaseDocCadastro,
  },
  data() {
    return {
      documentos: [],
      erro: null,
      docSelect: null,
      exibirModal: false
    }
  },
  emits: ["fechar", "atualizarListaDoc"],
  methods: {
    atualizarDoc(novoDoc) {
      if (Array.isArray(novoDoc)) {
        this.documentos.push(...novoDoc);
      } else {
        this.documentos.push(novoDoc);
      }
    },
    abrirModal() {
      this.exibirModal = true
    },
    fecharModal() {
      this.exibirModal = false
    },
    deletarDocModelo(docKey, docId, docDescricao) {
      let url = apiUrl.documentos.destroy(docKey);
      alertDelete(docKey, url, 'Você deseja deletar o registro?', `ID: ${docId} | ${docDescricao}`);
    },
    async getDados() {
      const resultado = await apiRequest("GET", apiUrl.documentos.list(this.itemKey));
      if (resultado.success) {
        this.documentos = resultado.data.data;
      }
    },
  },
  mounted() {
    this.getDados();
  },
}
</script>

<style scoped>
  .cursor-pointer {
    cursor: pointer;
  }
</style>
